module.exports = __webpack_public_path__ + "static/media/00453-SE MODIFICA ARTICULO 27 DE LA RESOL 00376 DEL 19 ENERO 2024.e34dc6a6.pdf";